/* eslint-disable @typescript-eslint/naming-convention */
import { ANALYTICS_ACTIONS, EVENT_NAMES } from '../constants';
import { trackHelper } from '../utils';
import { screensMap } from '@/views';
import { USER_TYPE } from '@/constants';

type analyticsDatatype = Record<string, any>;

export const trackLandingScreenRender = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.FC_HOME_PAGE_RENDER,
    actionName: ANALYTICS_ACTIONS.RENDER,
    screen: screensMap.LANDING,
    properties: {
      ...data,
    },
  });
};

export const trackEditContactClicked = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.FC_HOME_PAGE_MOBILE_NUMBER_EDIT,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      ...data,
    },
  });
};

export const trackInputClicked = (): void => {
  trackHelper({
    objectName: EVENT_NAMES.FC_HOME_PAGE_MOBILE_NUMBER_CLICK,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      user_type: USER_TYPE.NON_LOGGED_IN,
    },
  });
};

export const trackLandingCTAClick = (data: analyticsDatatype, cta: string): void => {
  trackHelper({
    objectName: cta === 'otp' ? EVENT_NAMES.FC_HOME_PAGE_SEND_OTP : EVENT_NAMES.GET_STARTED_CLICK,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      user_type: USER_TYPE.NON_LOGGED_IN,
      ...data,
    },
  });
};

export const trackSubmitOtpClicked = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.SUBMIT_OTP_CLICK,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      user_type: USER_TYPE.NON_LOGGED_IN,
      ...data,
    },
  });
};

export const trackConsentBoxClicked = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.CONSENT_BOX_CLICK,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      ...data,
    },
  });
};

export const trackUserExits = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.USER_EXITS,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      ...data,
    },
  });
};

export const trackUserRetention = (data: analyticsDatatype): void => {
  trackHelper({
    objectName: EVENT_NAMES.USER_EXITS_RETENTION,
    actionName: ANALYTICS_ACTIONS.CLICK,
    screen: screensMap.LANDING,
    properties: {
      ...data,
    },
  });
};
